import { render, staticRenderFns } from "./RSingleSelect.vue?vue&type=template&id=28bb8827&scoped=true&"
import script from "./RSingleSelect.vue?vue&type=script&lang=js&"
export * from "./RSingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./RSingleSelect.vue?vue&type=style&index=0&id=28bb8827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb8827",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VProgressCircular,VRow})
